module.exports = __webpack_public_path__ + "img/skating001.4a0d4e72.jpg";